import { gsap } from "gsap";

// Lazy load plugins to reduce initial bundle size
let scrollTrigger: any = null;
let scrollSmoother: any = null;
let splitText: any = null;

// Lazy load ScrollTrigger
export const loadScrollTrigger = async () => {
  if (!scrollTrigger) {
    const { ScrollTrigger } = await import("gsap/ScrollTrigger");
    gsap.registerPlugin(ScrollTrigger);
    scrollTrigger = ScrollTrigger;
  }
  return scrollTrigger;
};

// Lazy load ScrollSmoother
export const loadScrollSmoother = async () => {
  if (!scrollSmoother) {
    const { ScrollSmoother } = await import("gsap/ScrollSmoother");
    gsap.registerPlugin(ScrollSmoother);
    scrollSmoother = ScrollSmoother;
  }
  return scrollSmoother;
};

// Lazy load SplitText
export const loadSplitText = async () => {
  if (!splitText) {
    const { SplitText } = await import("gsap/SplitText");
    gsap.registerPlugin(SplitText);
    splitText = SplitText;
  }
  return splitText;
};

// Export GSAP and its utilities
export { gsap };
export const gsapUtils = gsap.utils;

// For backward compatibility, export as functions that load the plugins
export const ScrollTrigger = () => loadScrollTrigger();
export const ScrollSmoother = () => loadScrollSmoother();
export const SplitText = () => loadSplitText();
